/**
 * ConsentService Component
 *
 * Displays a single service with toggle.
 */

import type { ConsentService as ServiceType } from './types';
import styles from './Consent.module.css';

interface ConsentServiceProps {
  service: ServiceType;
  checked: boolean;
  onChange: () => void;
}

export function ConsentService({ service, checked, onChange }: ConsentServiceProps) {
  const isLocked = service.locked;

  return (
    <div className={styles.service}>
      <div className={styles.serviceInfo}>
        <span className={styles.serviceName}>{service.name}</span>
        <span className={styles.serviceDescription}>{service.description}</span>
      </div>
      <label className={`${styles.toggle} ${isLocked ? styles.toggleLocked : ''}`}>
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          disabled={isLocked}
        />
        <span className={styles.toggleSlider} />
      </label>
    </div>
  );
}
